module.exports = __webpack_public_path__ + "static/media/20240506134340_IMG_6733.18fade2d.JPG";